export default {
  toolBox: {
    title: "Helpful Tip",
    text: "This profile can populate the following:",
    formsArray: [
      {
        formCommonName: "PERM PERMANENT EMPLOYMENT CERTIFICATION",
        formGovName: "FORM ETA-9089",
        sections: ["APPENDIX A"],
      },
    ],
  },
};
